<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />
<div class="k-overlay" *ngIf="editWinOpen"></div>

<ng-template #template let-anchor>
  <span *ngIf="anchor.nativeElement.nodeName === 'LI'">{{ anchor.nativeElement['attributes']['aria-label'].value
    }}</span>
  <span *ngIf="anchor.nativeElement.nodeName !== 'LI'">{{
    anchor.nativeElement.parentElement.parentElement['attributes']['aria-label'].value }}</span>
</ng-template>

<div class="container-fluid gx-5">
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header">
          <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'users-gear']"></fa-icon> Tracker
        </h3>
      </div>

      <div class="bg-light p-2 rounded-lg rounded-2">
        <form class="k-form-horizontal">
          <div class="row g-3 align-items-center">
            <div class="col-4 k-form-field">
              <label for="project_name" class="form-label col-1 k-label">Project</label>
              <div style="width: 100%;">
                <kendo-dropdownlist [data]="projects" id="project_name" [(value)]="currentProject" textField="project_name"
                  valueField="id" (valueChange)="projectValueChange($event)"
                  [defaultItem]="defaultProjectItem"></kendo-dropdownlist>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- <div>
        <p>User Stories</p>
        <p>{{$userStories | async | json}}</p>
      </div> -->

      <div class="custom-toolbar">
        <!-- <div kendoTooltip> -->
        <!-- <button kendoButton [svgIcon]="menuSvg" fillMode="flat" (click)="drawer.toggle()"></button> -->
        <!-- <span class="mail-box">Mail Box</span> -->
        @if(drawExpanded === true) {
        <button kendoButton fillMode="flat" (click)="toggleDraw()" title="Contract sidebar">
          <fa-icon class="fa-solid fa-duotone fa-2xl" [icon]="['fad', 'outdent']"></fa-icon>
        </button>
        <!-- <span><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'chevrons-left']"></fa-icon></span> -->
        <!-- <button kendoButton fillMode="flat" (click)="toggleDraw()"> <fa-icon class="fa-solid fa-duotone"
            [icon]="['fad', 'chevrons-right']"></fa-icon></button> -->
        }
        @else {
        <button kendoButton fillMode="flat" (click)="toggleDraw()" title="Expand sidebar">
          <fa-icon class="fa-solid fa-duotone fa-2xl" [icon]="['fad', 'indent']"></fa-icon>
        </button>
        <!-- <span><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'chevrons-right']"></fa-icon></span> -->
        <!-- <button kendoButton fillMode="flat" (click)="toggleDraw()"> <fa-icon class="fa-solid fa-duotone"
            [icon]="['fad', 'chevrons-left']"></fa-icon></button> -->
        }
        <!-- </div> -->
      </div>
      <!-- <p>Draw Expanded: {{drawExpanded}}</p> -->

      <kendo-drawer-container>
        <div kendoTooltip showOn="none" (mouseover)="showTooltip($event)" [tooltipTemplate]="template" position="right"
          filter=".k-drawer li">
          <kendo-drawer #drawer [items]="items" mode="push" [mini]="true" [expanded]="drawExpanded"
            (select)="onSelect($event)" [autoCollapse]="false">
          </kendo-drawer>
        </div>

        <kendo-drawer-content>
          <casi-tile-layout [selectedUserStoryId]="selectedUserStoryId" [userStories]="userStories" [tiles]="tiles" [users]="users" [storyStatus]="storyStatus"
            [storyTypes]="storyTypes" [storyPriorities]="storyPriorities" [storyEstimates]="storyEstimates"
            (onCloseTile)="handleTileClose($event)"></casi-tile-layout>

        </kendo-drawer-content>
      </kendo-drawer-container>
    </div>
  </div>

</div>

<kendo-window *ngIf="editWinOpen" (close)="close()" [width]="1000"
  autoFocusedElement="#project_name">
  <kendo-window-titlebar>
    <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
      </span> {{showTitle}}</span>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <casi-user-story-modal [storyStatuses]="storyStatus"
      [storyTypes]="storyTypes"
      [storyPriorities]="storyPriorities"
      [storyEstimates]="storyEstimates"
      [users]="users"(onSave)="onUserStorySave()"
    (onCancel)="closeUserStory()">
    </casi-user-story-modal>
</kendo-window>
